<template>
    <div class="assignAuditPermission">
        <td-dialog
            :title="$t('assignAuditPermission.ASSIGN_AUDIT_PERMISSION')"
            width="680px"
            :before-close="dialogClose"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form labelWidth="85px">
                <el-form-item :label="$t('assignAuditPermission.ASSIGN_TYPE')">
                    <td-radio v-model="assignMethod.value" :options="assignMethod.options" @change="assignMethodChange()"></td-radio>
                </el-form-item>
                <!--指定分配表单-->
                <el-row class="assign">
                    <el-form-item v-if="assignMethod.value === 0" :label="$t('assignAuditPermission.ASSIGN_USER')">
                        <td-input v-model="userNameStr" :readonly="true">
                            <td-button type="text" slot="append" @click="btnSetUserNode">{{ $t('assignAuditPermission.SELECT') }}</td-button>
                        </td-input>
                    </el-form-item>
                    <el-form-item v-if="assignMethod.value === 0" :label="$t('assignAuditPermission.ASSIGN_ROLE')">
                        <td-input v-model="roleNameStr" :readonly="true">
                            <td-button type="text" slot="append" @click="btnSetRole">{{ $t('assignAuditPermission.SELECT') }}</td-button>
                        </td-input>
                    </el-form-item>
                    <el-form-item v-if="assignMethod.value === 0" :label="$t('assignAuditPermission.ASSIGN_ORG')">
                        <td-tree-select
                            ref="tdOrgTree"
                            nodeKey="id"
                            :defaultProps="deviceProps"
                            :imgloading="true"
                            :multiple="true"
                            :interfaceName="orgInterfaceName"
                            :calInternal="true"
                            :params="params"
                            :lazyloading="true"
                            v-model="orgIds"
                            :width="400"
                            :showBox="true"
                            :expandOnClick="true"
                        ></td-tree-select>
                    </el-form-item>
                </el-row>
                <!--自定义分配-->
                <el-row v-if="assignMethod.value === 1">
                    <el-col :span="11">
                        <el-form-item :label="$t('assignAuditPermission.ASSIGN_USER')">
                            <td-radio v-model="assignUserRadio.value" :options="assignUserRadio.options" @change="assignChange()"></td-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item labelWidth="0">
                            <td-select
                                v-if="assignUserRadio.value === 0"
                                v-model="auditPermissionInfo.userInputs"
                                style="margin-left: 10px"
                                multiple="true"
                                :options="assignUserSelect.options"
                                keys="sExtendGroupElementId"
                                text="sViewName"
                            ></td-select>
                            <td-tree-select
                                v-if="assignUserRadio.value === 1"
                                v-model="auditPermissionInfo.sAuditGroupInfo"
                                ref="auditTree"
                                nodeKey="id"
                                :defaultProps="defaultProps"
                                :imgloading="true"
                                :multiple="false"
                                :interfaceName="interfaceName"
                                :calInternal="true"
                                :lazyloading="true"
                                :params="initTreeParams"
                                @isChosen="isChosen"
                                @clickSelect="clickSelect"
                                @handleClose="auditClear"
                            ></td-tree-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="assignMethod.value === 1 && assignUserRadio.value === 1">
                    <el-form-item :label="$t('assignAuditPermission.ORG')">
                        <td-select
                            v-model="auditPermissionInfo.sOrgInput"
                            width="400"
                            :options="orgOptions"
                            keys="sExtendGroupElementId"
                            text="sViewName"
                            :disabled="auditPermissionInfo.sAuditGroupInfo == '' || auditPermissionInfo.sAuditGroupInfo.length == 0"
                        >
                        </td-select>
                    </el-form-item>
                    <div style="max-height: 400px; padding: 2px 0; overflow-y:auto;" v-if="showVisible">
                        <el-form-item class="expandedCondition" v-for="(item, index) in expandConditions" :key="index" :label="$t('assignAuditPermission.EXTEND_CONDITIONS') + (index + 1)">
                            <td-select
                                v-model="item.sLabelGroupId"
                                style="margin-right: 10px"
                                width="310"
                                :url="labelGroupInterfaceName"
                                :urlParam="labelGroupParam"
                                :pageSize="10"
                                keys="sId"
                                text="sRemark"
                                :isPage="true"
                                requestType="post"
                                @blur="conditionChange(item)"
                            >
                            </td-select>
                            <td-button class="conditionAdd" v-if="index === expandConditions.length - 1 && btnVisible" @click="addExpandCondition()">{{ $t('pgCommon.ADD') }}</td-button>
                            <p class="connectWord" v-if="index !== expandConditions.length - 1">{{ $t('assignAuditPermission.ALSO') }}</p>
                            <td-button type="text" :disabled="index === 0 && Array.isArray(expandConditions) && expandConditions.length === 1" @click="deleteExpandCondition(index)">{{
                                $t('assignAuditPermission.DELETE_EXTENSION_CONDITION')
                            }}</td-button>
                        </el-form-item>
                    </div>
                </el-row>
            </el-form>
            <div slot="footer">
                <td-button type="primary" :loading="submitLoading" @click="save()">{{ $t('extendCommon.SAVE') }}</td-button>
                <td-button @click="dialogClose">{{ $t('extendCommon.CANCEL') }}</td-button>
            </div>
        </td-dialog>
        <!-- 分配用户dialog -->
        <userDialog
            v-if="dialogUserVisible"
            :dialogUserVisible="dialogUserVisible"
            :templateKey="workFlowKey"
            :userParam="param"
            :userNames="userNames"
            :currPage="currPage"
            :userIds="userIds"
            @userDialogClose="userDialogClose"
            @submit="userSubmit"
        ></userDialog>
        <!-- 分配角色dialog -->
        <dialogRole
            v-if="setRoleVisible"
            :setRoleVisible="setRoleVisible"
            :templateKey="workFlowKey"
            :setRoleInfo="param"
            :selectedData="roleIds"
            @setRoleDialogClose="setRoleDialogClose"
            @submit="roleSubmit"
        ></dialogRole>
    </div>
</template>

<script>
import Api from '../assets/api';
import userDialog from './userDialog.vue';
import dialogRole from './dialogRole.vue';
export default {
    // 初始化渲染
    components: {
        dialogRole,
        userDialog
    },
    name: 'assignAuditPermissionDialog',
    props: ['dialogVisible', 'param', 'workFlowKey'],
    data() {
        return {
            submitLoading: false,
            dialogUserVisible: false,
            setRoleVisible: false,
            //分配方式radio绑定值
            assignMethod: {
                value: 0,
                options: [
                    { value: 0, label: this.$t('assignAuditPermission.ASSIGN') },
                    {
                        value: 1,
                        label: this.$t('assignAuditPermission.CUSTOM_ASSIGN')
                    }
                ]
            },
            //分配用户
            assignUserRadio: {
                value: 0,
                options: [
                    { value: 0, label: this.$t('assignAuditPermission.SPECIFY_USER') },
                    {
                        value: 1,
                        label: this.$t('workFlowProcessAudit.AUDIT_FILE')
                    }
                ]
            },
            deviceProps: {
                parentId: 'parentId',
                children: 'children',
                id: 'id',
                label: 'caption',
                imgName: 'sIcon'
            },
            params: {
                //过滤掉未分配组织
                unNeedNotDistribution: true
            },
            orgInterfaceName: { query: '/OrgStructureController/findOrgStructureTree', search: '/OrgStructureController/findOrgStructureTree' },
            orgIds: [],
            assignUserSelect: {
                value: '',
                options: []
            },
            interfaceName: { query: '/auditGroupManage/queryAuditTree', search: '/auditGroupManage/queryAuditNode' },
            initTreeParams: { parentId: '0001', pageNum: 1 }, //用于档案树形初始化
            defaultProps: { label: 'sName', id: 'id', children: 'children', imgName: 'sIcon', parentId: 'sParentId' },
            //组织架构下拉框选项列表
            orgOptions: [],
            expandConditions: [{ sLabelGroupId: '', iCondition: 0 }], //扩展条件
            auditPermissionInfo: {
                sId: '',
                userInputs: [],
                iConditions: '', //条件组
                sAuditGroupId: '', //档案id
                sAuditGroupInfo: [],
                sLabelGroupIds: '',
                sOrgInput: '' //组织架构输入框
            },
            showVisible: false,
            labelGroupInterfaceName: '/workFlowLabelGroup/queryLabelGroup',
            allIdList: [], //选择档案下对应扩展组的所有id
            labelGroupParam: {
                idList: [],
                needPage: true
            },
            labelGroupMaxLength: 0,
            btnVisible: true,
            oldAuditGroupId: '',
            userNameStr: '',
            userNames: [],
            currPage: [],
            userIds: [],
            saveNodeUserParam: {},
            roleIds: [],
            roleNameStr: '',
            saveRoleParam: {},
            saveOrgParam: {}
        };
    },
    mounted() {
        // 分配用户/角色/组织回显数据
        this.queryUserRoleOrgInfo();
        this.initSelectInfo();
        //查询自定义审核信息
        this.queryCustomAuditInfo();
    },
    methods: {
        //分配用户
        btnSetUserNode() {
            this.dialogUserVisible = true;
        },
        //分配用户页面关闭
        userDialogClose() {
            this.dialogUserVisible = false;
        },
        //分配用户保存
        userSubmit(param) {
            this.dialogUserVisible = false;
            this.saveNodeUserParam = param;
            this.userNameStr = param.userNames;
            this.currPage = param.userIds.split(',');
            this.userIds = param.userIds.split(',');
            this.userNames = this.userNameStr.split(',');
        },
        //分配角色
        btnSetRole() {
            this.setRoleVisible = true;
        },
        //分配角色页面关闭
        setRoleDialogClose() {
            this.setRoleVisible = false;
        },
        //分配角色页面提交
        roleSubmit(param) {
            this.setRoleVisible = false;
            this.saveRoleParam = param;
            this.roleNameStr = param.userRoleNames;
            this.roleIds = param.userRoleIds.split(',');
        },
        //判断档案树形节点是否可点
        isChosen(data) {
            if (this.$refs.auditTree) {
                if (data.iType === 0) {
                    this.$refs.auditTree.isSelect(false);
                } else {
                    this.$refs.auditTree.isSelect(true);
                }
            }
        },
        clickSelect(data) {
            if (data.id != this.oldAuditGroupId) {
                this.expandConditions = [{ sLabelGroupId: '', iCondition: 0 }];
            }
            //重新选择档案会清空扩展信息
            if (data.sLabelGroupIds.length > 0) {
                this.allIdList = data.sLabelGroupIds.split(',');
                this.labelGroupParam.idList = JSON.parse(JSON.stringify(this.allIdList));
                this.showVisible = true;
                this.labelGroupMaxLength = this.labelGroupParam.idList.length;
            } else {
                this.showVisible = false;
                this.labelGroupMaxLength = 0;
                this.oldAuditGroupId = '';
            }
            this.oldAuditGroupId = data.id;
        },
        auditClear() {
            this.showVisible = false;
            this.labelGroupMaxLength = 0;
            this.auditPermissionInfo.sOrgInput = '';
            this.oldAuditGroupId = '';
        },
        assignMethodChange() {
            //给一个默认值
            // this.assignUserRadio.value = 0;
        },
        assignChange() {
            if (this.assignUserRadio.value == 0) {
                this.auditPermissionInfo.sAuditGroupInfo = [];
                this.auditPermissionInfo.sAuditGroupId = '';
                this.auditClear();
            } else {
                this.auditPermissionInfo.userInputs = [];
            }
        },
        //查询自定义审核信息
        queryCustomAuditInfo() {
            let param = {
                sProKey: this.workFlowKey,
                sTaskKey: this.param.taskKey,
                proDefId: this.workFlowKey + ':TEMP' //使用临时版本版本
            };
            Api.queryCustomAuditInfo(param, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/customAudit/queryCustomAuditInfo', response.data.statusMessage);
                    return;
                }
                let data = response.data.content[0];
                this.auditPermissionInfo.sId = data.sId;
                this.assignUserRadio.value = data.iType; // 0- 自定义用户 1-档案
                if (data.iType === 0) {
                    this.auditPermissionInfo.userInputs = data.userInputList;
                } else {
                    let _this = this;
                    _this.expandConditions = data.relateList;
                    _this.auditPermissionInfo.sOrgInput = data.sOrgInput;
                    _this.oldAuditGroupId = data.sAuditGroupId;
                    _this.querysAuditGroupInfo(data.sAuditGroupId);
                }
            });
        },
        //根据档案id查询档案具体信息
        querysAuditGroupInfo(id) {
            if (this.$util.isEmpty(id)) {
                return;
            }
            let param = { sId: id };
            Api.queryAuditTree(param, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/auditGroupManage/queryAuditTree', response.data.statusMessage);
                    return;
                }
                this.auditPermissionInfo.sAuditGroupInfo = response.data.content;
            });
        },
        //处理分配组织参数
        getOrgParam() {
            let roleIdStr = '';
            let roleNameStr = '';
            for (let obj in this.orgIds) {
                if (roleIdStr === '') {
                    roleIdStr += this.orgIds[obj].id;
                    if (undefined != this.orgIds[obj].caption && 'undefined' != this.orgIds[obj].caption) {
                        roleNameStr += this.orgIds[obj].caption;
                    } else {
                        roleNameStr += this.$t('pgCommon.NOT_HAVE');
                    }
                } else {
                    roleIdStr += ',' + this.orgIds[obj].id;
                    if (undefined != this.orgIds[obj].caption && 'undefined' != this.orgIds[obj].caption) {
                        roleNameStr += ',' + this.orgIds[obj].caption;
                    } else {
                        roleNameStr += ',' + this.$t('pgCommon.NOT_HAVE');
                    }
                }
            }
            if (!this.orgIds.length || this.orgIds.length == 0) {
                roleIdStr = 'null';
            }
            this.saveOrgParam = {
                processDefKey: this.workFlowKey,
                taskDefKey: this.param.taskKey,
                roleIds: roleIdStr,
                roleNames: roleNameStr,
                proDefId: this.workFlowKey + ':TEMP', //适配版本切换，配置页面只能看到临时版本
                flag: this.param.tasksFlag
            };
        },
        /**
         * 分配审核权限弹窗事件
         */
        save() {
            if (this.assignMethod.value == 0) {
                this.submitLoading = true;
                //获取组织保存参数
                this.getOrgParam();
                let param = [this.saveNodeUserParam, this.saveRoleParam, this.saveOrgParam];
                //指定分配保存接口
                Api.batchSaveNodeUser(JSON.stringify(param), response => {
                    this.submitLoading = false;
                    if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
                        this.loading = false;
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.SAVE_SUCCESS'), type: 'success' });
                    this.dialogClose();
                });
            } else {
                let param = {
                    sId: this.auditPermissionInfo.sId,
                    sProKey: this.workFlowKey,
                    sTaskKey: this.param.taskKey,
                    proDefId: this.workFlowKey + ':TEMP', //适配版本切换，配置页面只能看到临时版本
                    iType: this.assignUserRadio.value
                };
                if (this.assignUserRadio.value === 0) {
                    param.sUserInputs = this.auditPermissionInfo.userInputs;
                } else {
                    if (this.auditPermissionInfo.sAuditGroupInfo.length > 0) {
                        if (!this.$util.isEmpty(this.expandConditions) && this.expandConditions.length > 0) {
                            //判断扩展条件是否重复
                            let customizationRelateVoList = [];
                            let ids = [];
                            let flag = true;
                            this.expandConditions.forEach(item => {
                                if (item.sLabelGroupId.length > 0) {
                                    if (ids.indexOf(item.sLabelGroupId) > -1) {
                                        flag = false;
                                        return;
                                    }
                                    ids.push(item.sLabelGroupId);
                                    customizationRelateVoList.push(item);
                                }
                            });
                            if (!flag) {
                                this.$message({ showClose: true, message: this.$t('pgMessage.LABEL_GROUP_NOREPEAT'), type: 'warning' });
                                return;
                            }
                            param.customizationRelateVoList = customizationRelateVoList;
                        }
                        param.sAuditGroupId = this.auditPermissionInfo.sAuditGroupInfo[0].id;
                        param.sOrgInput = this.auditPermissionInfo.sOrgInput;
                    }
                }
                //自定义分配保存接口
                Api.saveCustomization(param, response => {
                    if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/customAudit/saveCustomization', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.SAVE_SUCCESS'), type: 'success' });
                    this.dialogClose();
                });
            }
        },
        dialogClose() {
            this.$emit('dialogClose');
        },
        //添加扩展条件
        addExpandCondition() {
            this.expandConditions.push({ sLabelGroupId: '', iCondition: 0 });
            if (this.expandConditions.length >= this.labelGroupMaxLength) {
                this.btnVisible = false;
            }
        },
        //删除扩展条件
        deleteExpandCondition(index) {
            this.expandConditions.splice(index, 1);
            if (this.expandConditions.length < this.labelGroupMaxLength) {
                this.btnVisible = true;
            }
        },
        //扩展条件change事件
        conditionChange(item) {
            let expandConditions = this.expandConditions;
            let tempIdList = JSON.parse(JSON.stringify(this.allIdList));
            if (expandConditions && expandConditions.length !== 0) {
                expandConditions.forEach(item => {
                    if (!this.$util.isEmpty(item.sLabelGroupId)) {
                        tempIdList.splice(tempIdList.indexOf(item.sLabelGroupId), 1);
                    }
                });
            }
            tempIdList.push(item.sLabelGroupId);
            this.labelGroupParam.idList = tempIdList;
        },
        initSelectInfo() {
            let userParams = { sGroupId: this.workFlowKey + ':' + 'TEMP' + ':' + this.param.taskKey, iType: 0 };
            Api.queryExtendTypeByTask(userParams, response => {
                if (response.data.statusCode === 'API-COMMON-INF-OK') {
                    this.assignUserSelect.options = response.data.content;
                }
            });
            let orgParams = { sGroupId: this.workFlowKey + ':' + 'TEMP' + ':' + this.param.taskKey, iType: 2 };
            Api.queryExtendTypeByTask(orgParams, response => {
                if (response.data.statusCode === 'API-COMMON-INF-OK') {
                    this.orgOptions = response.data.content;
                }
            });
        },
        // 分配用户/角色/组织回显数据
        queryUserRoleOrgInfo() {
            let param = {
                sId: this.workFlowKey + this.param.taskKey,
                processDefKey: this.workFlowKey,
                taskDefKey: this.param.taskKey,
                proDefId: this.workFlowKey + ':TEMP' //适配版本切换，配置页面只能看到临时版本
            };
            Api.queryNodeUser(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('queryNodeUser', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('queryNodeUser', response.data.statusMessage);
                    return;
                }
                //保存用户参数
                this.saveNodeUserParam = {
                    processDefKey: this.workFlowKey,
                    taskDefKey: this.param.taskKey,
                    proDefId: this.workFlowKey + ':TEMP', //适配版本切换，配置页面只能看到临时版本
                    flag: this.param.tasksFlag
                };
                //保存角色参数
                this.saveRoleParam = {
                    processDefKey: this.workFlowKey,
                    taskDefKey: this.param.taskKey,
                    proDefId: this.workFlowKey + ':TEMP', //适配版本切换，配置页面只能看到临时版本
                    flag: this.param.tasksFlag
                };
                if (response.data.content.length > 0) {
                    let data = response.data.content[0];
                    //用户信息
                    let userIdStr = data.userIds;
                    this.userNameStr = data.userNames;

                    if (null != userIdStr && '' != userIdStr) {
                        this.currPage = userIdStr.split(',');
                        this.userIds = userIdStr.split(',');
                        this.userNames = this.userNameStr.split(',');

                        this.saveNodeUserParam.userIds = userIdStr;
                        this.saveNodeUserParam.userNames = this.userNameStr;
                    }

                    //角色信息
                    let userRoleIds = data.userRoleIds;
                    this.roleNameStr = data.userRoleNames;
                    if (null != userRoleIds && '' != userRoleIds) {
                        this.roleIds = userRoleIds.split(',');

                        this.saveRoleParam.userRoleIds = userRoleIds;
                        this.saveRoleParam.userRoleNames = this.roleNameStr;
                    }

                    //组织信息
                    let orgStr = data.roleIds;
                    if (null != orgStr && '' != orgStr) {
                        let objs = [];
                        this.orgIds = orgStr.split(',');
                        let arrName = data.roleNames.split(',');
                        for (let index = 0; index < this.orgIds.length; index++) {
                            let obj = { id: this.orgIds[index], caption: arrName[index] };
                            objs.push(obj);
                        }
                        this.$refs.tdOrgTree.dataDisplay(objs);
                    }
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.assignAuditPermission >>> .el-dialog__body {
    padding-left: 50px;
}
.assignAuditPermission .el-input {
    width: 400px !important;
}
.customAssign .el-input {
    width: 210px !important;
}
.assignAuditPermission .el-input-group__append .el-button--text {
    min-width: 50px;
    border-radius: 0 4px 4px 0;
}

.expandedCondition {
    .conditionAdd {
        width: 80px;
        min-width: 80px;
    }
    .connectWord {
        width: 80px;
        display: inline-block;
        text-align: center;
    }
}
.skinTwo {
    //文本按钮样式
    .el-button--text {
        color: rgb(16, 192, 255);
    }
    .el-button--text:hover,
    .el-button--text:focus {
        color: rgb(112, 212, 255);
        text-decoration: underline;
    }
    .el-button--text:active {
        color: rgb(0, 154, 198);
        text-decoration: underline;
    }
    //不可点击按钮样式
    .el-button.is-disabled,
    .el-button.is-disabled:hover {
        color: #47799e;
        background-color: transparent;
        text-decoration: none;
    }
}
</style>
